import { Box, Button, Checkbox, FormControlLabel, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import GiftItemForm from "./GiftItemForm";
import { GiftItem, userState } from "../../../../interface/MainInterface";

interface PropsType {
  userState: userState;
  title: string;
  flag: string;
  createGameFn: (
    eventName: string,
    isFcfs: boolean,
    timeoutMin: number,
    timeoutSec: number,
    giftList: GiftItem[]
  ) => void;
  closeCreateEventForm: () => void;
}

const CreateEventForm = ({ userState, title, flag, createGameFn, closeCreateEventForm }: PropsType) => {
  const [isFcfs, setIsFcfs] = useState(false);
  const [eventName, setEventName] = useState("");
  const [timeoutMin, setTimeoutMin] = useState(0);
  const [timeoutSec, setTimeoutSec] = useState(0);
  const [canCreateEvnt, setCanCreateEvnt] = useState(false);

  // 경품 리스트
  const [gifts, setGifts] = useState<GiftItem[]>([{ ofrSeq: "1", ofrNm: "", offrQty: 0, imgPath: "" }]);

  // gift 변경
  const updateGift = (index: number, updated: Partial<GiftItem>) => {
    setGifts((prev) => prev.map((g, idx) => (idx === index ? { ...g, ...updated } : g)));
  };

  // gift 삭제
  const deleteGift = (index: number) => {
    setGifts((prev) => prev.filter((_, idx) => idx !== index));
  };

  useEffect(() => {
    const isEventNameValid = eventName.trim() !== "";

    const areGiftsValid = gifts.every((gift) => gift.ofrNm.trim() !== "" && gift.offrQty > 0);

    setCanCreateEvnt(isEventNameValid && areGiftsValid);
  }, [eventName, gifts]);

  return (
    <>
      <Stack spacing={2} useFlexGap>
        <Stack direction="row" spacing={2} useFlexGap sx={{ alignItems: "center" }}>
          <Typography sx={{ fontSize: "14px", fontWeight: "700" }}>{title}</Typography>
          {flag !== "game" && (
            <Stack direction="row" spacing={1.5} useFlexGap sx={{ alignItems: "center" }}>
              <FormControlLabel
                label="※ 선착순 여부"
                labelPlacement="start"
                control={<Checkbox checked={isFcfs} onChange={(e) => setIsFcfs(e.target.checked)} />}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    color: "red",
                    fontWeight: 700,
                  },
                  gap: 0,
                }}
              />
              <Typography sx={{ fontWeight: 500, color: "blue", fontSize: "14px" }}>
                미선택 시 당첨자 선정 기준은 랜덤으로 선정
              </Typography>
            </Stack>
          )}
        </Stack>
        <TextField
          label="이벤트명"
          id="eventName"
          value={eventName}
          placeholder="이벤트명을 입력하세요."
          variant="outlined"
          autoFocus
          fullWidth
          required
          size="small"
          type="search"
          autoComplete="off"
          inputProps={{ enterKeyHint: "Enter" }}
          onChange={(e) => setEventName(e.target.value)}
        />
        <Stack direction="row" spacing={2} useFlexGap>
          <TextField
            label="제한시간(분)"
            value={timeoutMin}
            variant="outlined"
            type="number"
            size="small"
            fullWidth
            inputProps={{
              min: 0,
            }}
            onChange={(e) => setTimeoutMin(Number(e.target.value))}
            onBlur={(e) => {
              if (!e.target.value) {
                setTimeoutMin(0);
              }
            }}
          />
          <TextField
            label="제한시간(초)"
            value={timeoutSec}
            variant="outlined"
            type="number"
            size="small"
            fullWidth
            inputProps={{
              min: 0,
            }}
            onChange={(e) => setTimeoutSec(Number(e.target.value))}
            onBlur={(e) => {
              if (!e.target.value) {
                setTimeoutSec(0);
              }
            }}
          />
        </Stack>
        <Stack spacing={3}>
          {gifts.map((gift, index) => (
            <GiftItemForm
              key={index}
              userState={userState}
              index={index}
              gift={gift}
              onChange={updateGift}
              onDelete={deleteGift}
            />
          ))}
        </Stack>

        {/* + 경품 추가 */}
        <Button
          variant="outlined"
          onClick={() =>
            setGifts((prev) => [...prev, { ofrSeq: `${gifts.length + 1}`, ofrNm: "", offrQty: 0, imgPath: "" }])
          }
        >
          + 경품 추가
        </Button>
      </Stack>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Stack direction={"row"} spacing={2}>
          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                createGameFn(eventName, isFcfs, timeoutMin, timeoutSec, gifts);
              }}
              disabled={!canCreateEvnt}
            >
              생성하기
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                closeCreateEventForm();
              }}
            >
              닫기
            </Button>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default CreateEventForm;
